import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'scroll-top-floating-component',
  templateUrl: './scroll-top-floating.component.html',
  styleUrls: ['./scroll-top-floating.component.scss']
})
export class ScrollTopFloatingComponent {
  public componentVisibility:boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  @HostListener('window:scroll',['$event']) 
    onScroll(e:Event):void{
      if(isPlatformBrowser(this.platformId) && window.scrollY > 200){
        this.componentVisibility = true
      } else {
        this.componentVisibility = false;
      }
  }

}
